import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { AgGridModule } from "ag-grid-angular";
import { LoaderComponent } from "../loader/loader.component";
import { MatComponentsModule } from "./../../mat-components.module";
import { AgGridCheckboxComponent } from './ag-grid-checkbox/ag-grid-checkbox.component';
import { CalendarDialogComponent } from "./calendar-dialog/calendar-dialog.component";
import { ClientModelComponent } from "./client-model/client-model.component";
import { ClientRolesComponent } from "./client-roles/client-roles.component";
import { DynamicPopupComponent } from './dynamic-popup/dynamic-popup.component';
import { FilterBadgesComponent } from './filter-badges/filter-badges.component';
import { PopupAlertComponent } from "./popup-alert/popup-alert.component";
import { PopupConfirmationComponent } from "./popup-confirmation/popup-confirmation.component";
import { PopupDeleteComponent } from "./popup-delete/popup-delete.component";
import { ScheduleFromDateToDateDialogComponent } from "./schedule-fromdate-todate/schedule-fromdate-todate.component";
import { MatIconModule } from "@angular/material/icon";
import { FailedalertComponent } from "./failedalert/failedalert.component";
import { HelpMenuComponent } from './help-menu/help-menu.component';
import { HelpInfoMonitorComponent } from './help-info-monitor/help-info-monitor.component';
import { ClientDetailsComponent } from "./client-details/client-details.component";
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { SafePipe } from "src/app/pipe/safe.pipe";
import { EmailModifyDialogComponent } from "../modules/operational-reports/components/emailconfigconsole/emailconfigsavedlist/emailconfigmodify/emailconfigmodify.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { InfoDialogComponent } from "./info-dialog/info-dialog.component";
import { EditOnScreenCardComponent } from "./edit-onscreen-card/edit-onscreen-card.component";
import { DynamicFormComponent } from "./dynamic-form/dynamic-form.component";

@NgModule({
  declarations: [
    ClientModelComponent,
    ClientRolesComponent,
    AgGridCheckboxComponent,
    PopupDeleteComponent,
    FilterBadgesComponent,
    PopupAlertComponent,
    LoaderComponent,
    DynamicPopupComponent,
    PopupConfirmationComponent,
    CalendarDialogComponent,
    ScheduleFromDateToDateDialogComponent,
    EmailModifyDialogComponent,
    FailedalertComponent,
    SafePipe,
    HelpMenuComponent,
    HelpInfoMonitorComponent,
    ClientDetailsComponent,
    InfoDialogComponent,
    EditOnScreenCardComponent,
    DynamicFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatComponentsModule,
    AgGridModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatDialogModule,
    OverlayModule,
    MatNativeDateModule,
    MatIconModule,
    MatSlideToggleModule,
    MatSnackBarModule
  ],
  exports: [
    ClientModelComponent,
    ClientRolesComponent,
    AgGridCheckboxComponent,
    PopupDeleteComponent,
    FilterBadgesComponent,
    PopupAlertComponent,
    LoaderComponent,
    DynamicPopupComponent,
    HelpMenuComponent,
    HelpInfoMonitorComponent,
    MatSlideToggleModule,
    SafePipe,
    InfoDialogComponent,
    EditOnScreenCardComponent,
    DynamicFormComponent
  ],
  bootstrap: [],
  providers: [{ provide: MatDialogRef, useValue: {} }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedComponentModule {}
